import { useTranslation } from "react-i18next";

import { SUPPORTED_LOCALES } from "@/shared/i18n";
import { cn } from "@/shared/lib/cn";

/** Bascule de langue. `<select>` natif : accessible au clavier sans effort. */
export function LocaleSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? "fr";

  return (
    <label className="text-sm">
      <span className="sr-only">{current}</span>
      <select
        value={current}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
        className={cn(
          "rounded border border-slate-300 bg-white px-2 py-1 text-sm",
          "dark:border-slate-700 dark:bg-slate-900",
        )}
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {locale.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
}
